import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import VuePageTransition from 'vue-page-transition'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faUserSecret,faUser,faLock,faBell,faCircleCheck,faMapPin} from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faUserSecret,faUser,faLock,faBell,faCircleCheck,faMapPin)
/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueQuillEditor, {
    theme: "snow",
    modules: {
        toolbar: [['bold', 'italic', 'underline'], [{'header': 1}, {'header': 2}]]
    }
})
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueI18n);
Vue.use(VuePageTransition);

export function apiUrl() {
    //return "http://localhost:3000";
    return "https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/";
}

import LoginBody from './components/LoginBody.vue'
import Browse from './components/Browse.vue'
import VR from './Editors/Create/VR.vue'
//import Browse2 from './components/Browse.vue'
import ResetRequest from './components/PWReset/ResetRequest.vue'
import VideoContainer from './components/VideoPlayer/VideoContainer'
import AdminPanel from './components/TenantList/AdminPanel'
import TeacherPanel from './components/UserList/TeacherPanel'
import ClassesPanel from './components/ClassList/ClassesPanel'
import ClassEditPanel from './components/Class/ClassEditPanel'
import SetSecurityQuestions from './components/SetSecurityQuestions'
import EditStudentPanel from './components/EditStudent/EditStudentPanel'

import AssignmentsPanel from './components/AssignmentsList/AssignmentsPanel'
import AssignmentsResultsList from './components/AssignmentResultsList/AssignmentsResultsList'
import StudentAnswerViewer from './components/StudentAnswerViewer/StudentAnswerViewer'
import CreateAssignmentForm from './components/CreateAssignmentForm/CreateAssignmentForm'

import InteractiveVocab from './components/Interactive/Vocab/InteractiveVocab'
import InteractiveImage from './components/Interactive/Image/InteractiveImage'
import InteractiveBiography from './components/Interactive/Biography/InteractiveBiography'

import Timeline from './components/Interactive/Timeline/Timeline'
import Gallery from './components/Interactive/Gallery/Gallery'
import Jigsaw from './components/Interactive/Jigsaw/Jigsaw'

import Infographic1 from './components/Interactive/Infographic1/Infographic1'
import Infographic2 from './components/Interactive/Infographic2/Infographic2'
import Infographic3 from './components/Interactive/Infographic3/Infographic3'
import Infographic4 from './components/Interactive/Infographic4/Infographic4'
import Infographic5 from './components/Interactive/Infographic5/Infographic5'
import Infographic6 from './components/Interactive/Infographic6/Infographic6'
import Infographic7 from './components/Interactive/Infographic7/Infographic7'

import InteractiveVideo from './components/Interactive/VideoPlayer/VideoContainer'
import InteractiveAudio from './components/Interactive/AudioPlayer/Audio'

import LandingAdmin from './components/landing/admin'
import LandingStudent from './components/landing/student'
import LandingTeacher from './components/landing/teacher'

import EditorHome from './Editors/Home'

const routes = [
    {path: '/', component: LoginBody, props: true, name: "Login"},
    {path: '/browse/:browsetype', component: Browse, props: true},
    {path: '/VR',component: VR, props: true,meta:{title:"VR"}},
    {path: '/landing/admin', component: LandingAdmin, props: true , meta:{ title: "admin view"}},
    {path: '/landing/student', component: LandingStudent, props: true, meta:{ title: "student view"}},
    {path: '/landing/teacher', component: LandingTeacher, props: true, meta:{ title: "teacher view"}},
    //{ path: '/browse', component: Browse},
    {path: '/pwreset', component: ResetRequest, meta:{ title: "Reset"}},
    {path: '/video/:videofile', component: VideoContainer, props: true , meta:{ title: "Videos"} },
    {path: '/admin', component: AdminPanel, props: true, meta:{ title: "Admin"}},
    {path: '/students', component: TeacherPanel, props: true, meta:{ title: "Users"}},
    {path: '/classes', component: ClassesPanel, props: true , meta:{ title: "Classes"}},
    {path: '/classes/:classId', component: ClassEditPanel, props: true, meta:{ title: "Classes"}},
    {path: '/setsecurityquestions', component: SetSecurityQuestions, props: true, meta:{ title: "Questions"}},
    {path: '/students/:Id', component: EditStudentPanel, props: true, meta:{ title: "Users"}},

    {path: '/assignments', component: AssignmentsPanel, props: true, meta:{ title: "Assignments"} },
    {path: '/assignments/create', component: CreateAssignmentForm, props: true, meta:{ title: "Assignments"} },
    {path: '/assignments/results/:assignmentId', component: AssignmentsResultsList, props: true, meta:{ title: "Assignments"} },
    {path: '/assignments/results/:assignmentId/student/:studentId', component: StudentAnswerViewer, props: true, meta:{ title: "Assignments"} },

    {path: '/interactive/vocabulary/:vocabId', component: InteractiveVocab, props: true, meta:{ title: "Vocabulary"}},
    {path: '/interactive/image/:imageId', component: InteractiveImage, props: true, meta:{ title: "Image"}},
    {path: '/interactive/gallery/:galleryId', component: Gallery, props: true, meta:{ title: "Gallery"}},
    {path: '/interactive/biography/:biographyId', component: InteractiveBiography, props: true, meta:{ title: "Biography"}},
    {path: '/interactive/jigsaw/:jigsawId', component: Jigsaw, props: true, meta:{ title: "Jigsaw"}},
    {path: '/interactive/timeline/:timelineId', component: Timeline, props: true, meta:{ title: "Timeline"}},
    {path: '/interactive/infographic1/:infoId', component: Infographic1, props: true, meta:{ title: "Infographic"}},
    {path: '/interactive/infographic2/:infoId', component: Infographic2, props: true, meta:{ title: "Infographic"}},
    {path: '/interactive/infographic3/:infoId', component: Infographic3, props: true, meta:{ title: "Infographic"}},
    {path: '/interactive/infographic4/:infoId', component: Infographic4, props: true, meta:{ title: "Infographic"}},
    {path: '/interactive/infographic5/:infoId', component: Infographic5, props: true, meta:{ title: "Infographic"}},
    {path: '/interactive/infographic6/:infoId', component: Infographic6, props: true, meta:{ title: "Infographic"}},
    {path: '/interactive/map/:infoId', component: Infographic7, props: true, meta:{ title: "Map"}},
    {path: '/interactive/video/:videoId', component: InteractiveVideo, props: true, meta:{ title: "Video"}},
    {path: '/interactive/audio/:audioId', component: InteractiveAudio, props: true, meta:{ title: "Audio"}},

    {
        path: '/editors', component: EditorHome, props: true,
        meta:{ title: "Editors"},
        children: [
            {
                path: '/',
                component: () => import('@/Editors/Navigation.vue'),
                meta:{ title: "Editors"},
            },
            {
                path: 'component/:componentType',
                component: () => import('@/Editors/ComponentPage.vue'),
                props: true
            },
            {path: 'create/image', component: () => import('@/Editors/Create/Image.vue'), meta:{ title: "Image"}},
            {path: 'edit/image/:imageId', component: () => import('@/Editors/Create/Image.vue'), props: true, meta:{ title: "Image"}},
            {path: 'create/gallery', component: () => import('@/Editors/Create/Gallery.vue'), meta:{ title: "Gallery"}},
            {path: 'edit/gallery/:ID', component: () => import('@/Editors/Create/Gallery.vue'), props: true, meta:{ title: "Gallery"}},
            {path: 'create/biography', component: () => import('@/Editors/Create/Biography.vue'), meta:{ title: "Biography"}},
            {path: 'edit/biography/:imageId', component: () => import('@/Editors/Create/Biography.vue'), props: true},
            {path: 'create/vocabulary', component: () => import('@/Editors/Create/Vocab.vue'), meta:{ title: "Vocabulary"}},
            {path: 'edit/vocabulary/:ID', component: () => import('@/Editors/Create/Vocab.vue'), props: true, meta:{ title: "Vocabulary"}},
            {path: 'create/jigsaw', component: () => import('@/Editors/Create/Jigsaw.vue'), meta:{ title: "Jigsaw"}},
            {path: 'edit/jigsaw/:ID', component: () => import('@/Editors/Create/Jigsaw.vue'), props: true, meta:{ title: "Jigsaw"}},
            {path: 'create/timeline', component: () => import('@/Editors/Create/Timeline.vue'), meta:{ title: "Timeline"}},
            {path: 'edit/timeline/:ID', component: () => import('@/Editors/Create/Timeline.vue'), props: true, meta:{ title: "Timeline"}},
            {path: 'create/infographic1', component: () => import('@/Editors/Create/Infographic1.vue'), meta:{ title: "Infographic"}},
            {path: 'edit/infographic1/:ID', component: () => import('@/Editors/Create/Infographic1.vue'), props: true, meta:{ title: "Infographic"}},
            {path: 'create/infographic2', component: () => import('@/Editors/Create/Infographic2.vue'), meta:{ title: "Infographic"}},
            {path: 'edit/infographic2/:ID', component: () => import('@/Editors/Create/Infographic2.vue'), props: true, meta:{ title: "Infographic"}},
            {path: 'create/infographic3', component: () => import('@/Editors/Create/Infographic3.vue'), meta:{ title: "Infographic"}},
            {path: 'edit/infographic3/:ID', component: () => import('@/Editors/Create/Infographic3.vue'), props: true, meta:{ title: "Infographic"}},
            {path: 'create/infographic4', component: () => import('@/Editors/Create/Infographic4.vue'), meta:{ title: "Infographic"}},
            {path: 'edit/infographic4/:ID', component: () => import('@/Editors/Create/Infographic4.vue'), props: true, meta:{ title: "Infographic"}},
            {path: 'create/infographic5', component: () => import('@/Editors/Create/Infographic5.vue'), meta:{ title: "Infographic"}},
            {path: 'edit/infographic5/:ID', component: () => import('@/Editors/Create/Infographic5.vue'), props: true, meta:{ title: "Infographic"}},
            {path: 'create/infographic6', component: () => import('@/Editors/Create/Infographic6.vue'), meta:{ title: "Infographic"}},
            {path: 'edit/infographic6/:ID', component: () => import('@/Editors/Create/Infographic6.vue'), props: true, meta:{ title: "Infographic"}},
            {path: 'edit/map/:ID', component: () => import('@/Editors/Create/Infographic7.vue'), props: true, meta:{ title: "Map"}},
            {path: 'create/map', component: () => import('@/Editors/Create/Infographic7.vue'), meta:{ title: "Map"}},
            {path: 'create/LessonPlan', component: () => import('@/Editors/Create/LessonPlan.vue'), meta:{ title: "Lesson Plan"} },
            {path: 'edit/LessonPlan/:ID', component: () => import('@/Editors/Create/LessonPlan.vue'), props: true, meta:{ title: "Lesson Plan"} },
            {path: 'create/Video', component: () => import('@/Editors/Create/Video.vue'), meta:{ title: "Video"} },
            {path: 'edit/Video/:ID', component: () => import('@/Editors/Create/Video.vue'), props: true, meta:{ title: "Video"} },
            {path: 'create/Audio', component: () => import('@/Editors/Create/Audio.vue'), meta:{ title: "Audio"} },
            {path: 'edit/Audio/:ID', component: () => import('@/Editors/Create/Audio.vue'), props: true, meta:{ title: "Audio"} },
            {path: 'create/Featured', component: () => import('@/Editors/Create/Featured.vue'),props:true, meta:{ title: "Featured"} },
            {path: 'edit/Featured/:ID', component: () => import('@/Editors/Create/Featured.vue'), props: true, meta:{ title: "Featured"} },
            {path: 'create/pdf', component: () => import('@/Editors/Create/Pdf.vue'),props:true, meta:{ title: "PDF"} },
            {path: 'edit/pdf/:ID', component: () => import('@/Editors/Create/Pdf.vue'),props:true, meta:{ title: "PDF"} },
        ]
    }
];

const router = new VueRouter({
    routes // short for `routes: routes`
});

router.beforeEach((toRoute,fromRoute,next) => {
   window.document.title = toRoute.meta.title;
   next();
});

var cachedLocale = localStorage.getItem("Locale");

const i18n = new VueI18n(
    {
        locale: cachedLocale ? cachedLocale : "English",
        fallbackLocale: "English",
        messages:
            {
                English: {
                    AUDIO: "Audio",
                    CREATE_ASSIGNMENT: "Create Assignment",
                    USERNAME: "Username",
                    ENTER_USERNAME: "Enter username",
                    PASSWORD: "Password",
                    ENTER_PWD: "Enter password",
                    LOGIN: "Login",
                    STAY_SIGNED_IN: "Remember me",
                    FORGOT_PWD: "Forgot Username/ Password?",
                    LOGIN_PROBLEM: "There was a problem logging in, please try again.",
                    OK: "Okay",
                    CANCEL: "Cancel",
                    APPLY: "Apply",
                    NO_ASSIGNMENTS: "No assignments",
                    SEARCH: "Search",
                    CONTENT: "Content",
                    ASSIGNMENTS: "Your Assignments",
                    CLASS_ASSIGNMENTS: "Class Assignments",
                    LESSONS: "Lesson Plans/Resources",
                    VIDEOS: "Videos",
                    INTERACTIVE: "Interactive",
                    EDITORS: "Editors",
                    ADMIN: "Admin",
                    USERS: "Users",
                    STUDENTS: "Students",
                    CLASSES: "Classes",
                    USER: "User",
                    SIGN_OUT: "Sign out",
                    ID: "ID",
                    NAME: "Name",
                    SUFFIX: "Suffix",
                    TITLE: "Title",
                    CLASSNAME:"Class Name",
                    ASSIGNED_ON:"Assigned On",
                    DUE_ON:"Due On",
                    TEACHER_SEATS: "Teacher Seats",
                    STUDENT_SEATS: "Student Seats",
                    LICENSE_EXPIRES: "License Expires",
                    LICENSE_BEGINS: "License Starts",
                    EDIT: "Edit",
                    ASSUME: "Assume",
                    DELETE: "Delete",
                    NEW_TENANT: "New customer",
                    ENT_TEN_NAME: "Enter customer name",
                    ENT_TEN_SUFFIX: "Enter customer suffix",
                    CREATE: "Create",
                    EDIT_TENANT: "Edit customer",
                    UPDATE_TENANT: "Update customer",
                    CLASS: "Class",
                    SELECT_STUDENT: "Select Student",
                    ADD_TO_CLASS: "Add to class",
                    REMOVE: "Remove",
                    ENT_CLASS_NAME: "Enter class name",
                    NEW_CLASS: "New Class",
                    FIRSTNAME: "Firstname",
                    LASTNAME: "Lastname",
                    RESET_PW: "Reset Password",
                    ANSWER_SQ: "Answer your security questions",
                    F_SQ: "First Security Question",
                    S_SQ: "Second Security Question",
                    ENTER_ANSWER: "Enter your answer",
                    NEW_PW: "New password",
                    NEW_PW_AGAIN: "New password again",
                    SCHOOL: "School",
                    NEW_USER: "New User",
                    ENTER_USER_FIRSTNAME: "Enter user first name",
                    ENTER_USER_LASTNAME: "Enter user last name",
                    ENTER_USER_PASSWORD: "Enter user password",
                    ROLE: "Role",
                    NO_ENTRIES: "No entries",
                    SETUP_LATER: "Setup Later",
                    RESET_PASSWORD: "Reset Password",
                    GALLERY:"Gallery",
                    BIOGRAPHY:"Biography",
                    IMAGE:"Image",
                    JIGSAW:"Jigsaw",
                    VOCAB:"Vocab",
                    TIMELINE:"Timeline",
                    VIDEO:"Video",
                    INFOGRAPHIC1: "Infographic 1",
                    INFOGRAPHIC2: "Infographic 2",
                    INFOGRAPHIC3: "Infographic 3",
                    INFOGRAPHIC4: "Infographic 4",
                    INFOGRAPHIC5: "Infographic 5",
                    INFOGRAPHIC6: "Infographic 6",
                    BEGIN_PAGE:"Begin Page",
                    END_PAGE:"End Page",
                    FEATURED:"Featured",
                    VR: "VR"
                },
                Español: {
                        CREATE_ASSIGNMENT: "Crear asignación",
                        USERNAME: "Nombre de usuario",
                        ENTER_USERNAME: "Introduzca su nombre de usuario",
                        PASSWORD: "Contraseña",
                        ENTER_PWD: "Introducir la contraseña",
                        LOGIN: "Iniciar sesión",
                        STAY_SIGNED_IN: "Recuérdame",
                        FORGOT_PWD: "¿Olvidó su nombre de usuario / contraseña?",
                        LOGIN_PROBLEM: "Se produjo un problema al iniciar sesión. Vuelve a intentarlo.",
                        OK: "Bueno",
                        CANCEL: "Cancelar",
                        APPLY: "Aplicar",
                        NO_ASSIGNMENTS: "Sin asignaciones",
                        CLASS_ASSIGNMENTS: "Tareas de clase",
                        SEARCH: "Buscar",
                        CONTENT: "Contenido",
                        ASSIGNMENTS: "Tus asignaciones",
                        LESSONS: "Planes de lecciones/Recursos",
                        VIDEOS: "Videos",
                        INTERACTIVE: "Interactiva",
                        EDITORS: "Editoras",
                        ADMIN: "Administración",
                        USERS: "Los usuarios",
                        STUDENTS: "Estudiantes",
                        CLASSES: "Clases",
                        USER: "Usuaria",
                        SIGN_OUT: "Desconectar",
                        ID: "ID",
                        NAME: "Nombre",
                        SUFFIX: "Sufijo",
                        TITLE: "Título",
                        CLASSNAME:"Nombre de la clase",
                        ASSIGNED_ON:"Asignado el",
                        DUE_ON:"Debido a",
                        TEACHER_SEATS: "Asientos de maestro",
                        STUDENT_SEATS: "Asientos de estudiante",
                        LICENSE_EXPIRES: "La licencia caduca",
                        LICENSE_BEGINS: "Comienza la licencia",
                        EDIT: "Editar",
                        ASSUME: "Asumir",
                        DELETE: "Eliminar",
                        NEW_TENANT: "Nuevo inquilino",
                        ENT_TEN_NAME: "Ingrese el nombre del inquilino",
                        ENT_TEN_SUFFIX: "Ingrese el sufijo del inquilino",
                        CREATE: "Crear",
                        EDIT_TENANT: "Editar inquilino",
                        UPDATE_TENANT: "Actualizar inquilino",
                        CLASS: "Clase",
                        SELECT_STUDENT: "Seleccionar estudiante",
                        ADD_TO_CLASS: "Agregar a clase",
                        REMOVE: "Eliminar",
                        ENT_CLASS_NAME: "Ingrese el nombre de la clase",
                        NEW_CLASS: "Nueva clase",
                        FIRSTNAME: "Primer nombre",
                        LASTNAME: "Apellido",
                        RESET_PW: "Restablecer la contraseña",
                        ANSWER_SQ: "Responde tus preguntas de seguridad",
                        F_SQ: "Primera pregunta de seguridad",
                        S_SQ: "Segunda pregunta de seguridad",
                        ENTER_ANSWER: "Ingrese su respuesta",
                        NEW_PW: "Nueva contraseña",
                        NEW_PW_AGAIN: "Nueva contraseña de nuevo",
                        SCHOOL: "Colegio",
                        NEW_STUDENT: "Estudiante nuevo",
                        NEW_USER: "Nuevo usuario",
                        ENTER_USER_FIRSTNAME: "Ingrese el nombre del usuario",
                        ENTER_USER_LASTNAME: "Ingrese el apellido del usuario",
                        ENTER_USER_PASSWORD: "Introduzca la contraseña de usuario",
                        ROLE: "Papel",
                        NO_ENTRIES: "No entrar",
                        SETUP_LATER: "Configurar mas tarde",
                        RESET_PASSWORD:"Restablecer la contraseña",
                        GALLERY:"Galería",
                        BIOGRAPHY:"Biografía",
                        IMAGE:"Imagen",
                        JIGSAW:"Rompecabezas",
                        VOCAB:"vocabulario",
                        TIMELINE:"Cronología",
                        INFOGRAPHIC1: "Infografía 1",
                        INFOGRAPHIC2: "Infografía 2",
                        INFOGRAPHIC3: "Infografía 3",
                        INFOGRAPHIC4: "Infografía 4",
                        INFOGRAPHIC5: "Infografía 5",
                        INFOGRAPHIC6: "Infografía 6",
                        BEGIN_PAGE:"Página de inicio",
                        END_PAGE:"Página final",
                        VIDEO:"Video",
                        FEATURED:"Recomendados",
                    VR: "Realidad virtual"
                },
                Français: {
                        CREATE_ASSIGNMENT: "Créer une affectation",
                        USERNAME: "Nom d'utilisateur",
                        ENTER_USERNAME: "Saisissez votre nom d'utilisateur",
                        PASSWORD: "Mot de passe",
                        ENTER_PWD: "Entrer le mot de passe",
                        LOGIN: "S'identifier",
                        STAY_SIGNED_IN: "Souvenez-vous de moi",
                        FORGOT_PWD: "Nom d'utilisateur / mot de passe oublié?",
                        LOGIN_PROBLEM: "Un problème est survenu lors de la connexion. Veuillez réessayer.",
                        OK: "d'accord",
                        CANCEL: "Annuler",
                        APPLY: "Appliquer",
                        NO_ASSIGNMENTS: "Aucune affectation",
                        SEARCH: "Chercher",
                        CONTENT: "Contenu",
                        ASSIGNMENTS: "Vos missions",
                        CLASS_ASSIGNMENTS: "Devoirs de classe",
                        LESSONS: "Plans de cours/ressources",
                        VIDEOS: "Vidéos",
                        INTERACTIVE: "Interactive",
                        EDITORS: "Rédactrices",
                        ADMIN: "Admin",
                        USERS: "Utilisatrices",
                        STUDENTS: "Élèves",
                        CLASSES: "Des classes",
                        USER: "Utilisatrice",
                        SIGN_OUT: "Déconnexion",
                        ID: "ID",
                        NAME: "Nom",
                        SUFFIX: "Suffixe",
                        TITLE: "Titre",
                        CLASSNAME:"Nom du cours",
                        ASSIGNED_ON:"Attribué le",
                        DUE_ON:"Dû le",
                        TEACHER_SEATS: "Sièges d'enseignants",
                        STUDENT_SEATS: "Sièges étudiants",
                        LICENSE_EXPIRES: "Licence expirée",
                        LICENSE_BEGINS:"La licence démarre",
                        EDIT: "Modifier",
                        ASSUME: "Présumer",
                        DELETE: "Effacer",
                        NEW_TENANT: "Nouveau locataire",
                        ENT_TEN_NAME: "Entrez le nom du locataire",
                        ENT_TEN_SUFFIX: "Entrer le suffixe du locataire",
                        CREATE: "Créer",
                        EDIT_TENANT: "Modifier le locataire",
                        UPDATE_TENANT: "Mettre à jour le locataire",
                        CLASS: "Classe",
                        SELECT_STUDENT: "Sélectionnez étudiant",
                        ADD_TO_CLASS: "Ajouter à la classe",
                        REMOVE: "Retirer",
                        ENT_CLASS_NAME: "Entrez le nom de la classe",
                        NEW_CLASS: "Nouvelle classe",
                        FIRSTNAME: "Prénom",
                        LASTNAME: "Nom de famille",
                        RESET_PW: "réinitialiser le mot de passe",
                        ANSWER_SQ: "Répondez à vos questions de sécurité",
                        F_SQ: "Première question de sécurité",
                        S_SQ: "Deuxième question de sécurité",
                        ENTER_ANSWER: "Entrez votre réponse",
                        NEW_PW: "Nouveau mot de passe",
                        NEW_PW_AGAIN: "Répétez le nouveau mot de passe",
                        SCHOOL: "École",
                        NEW_USER: "Nouvel utilisateur",
                        ENTER_USER_FIRSTNAME: "Entrez le prénom de l'utilisateur",
                        ENTER_USER_LASTNAME: "Entrez le nom de famille de l'utilisateur",
                        ENTER_USER_PASSWORD: "Entrez le mot de passe de l'utilisateur",
                        ROLE: "Rôle",
                        NO_ENTRIES: "Aucune entrée",
                        SETUP_LATER: "Installer plus tard",
                        RESET_PASSWORD: "réinitialiser le mot de passe",
                        GALLERY:"Galerie",
                        BIOGRAPHY:"Biographie",
                        IMAGE:"Image",
                        JIGSAW:"Scie sauteuse",
                        VOCAB:"Vocabulaire",
                        TIMELINE:"Chronologie",
                        VIDEO:"Vidéo",
                        INFOGRAPHIC1: "Infographie 1",
                        INFOGRAPHIC2: "Infographie 2",
                        INFOGRAPHIC3: "Infographie 3",
                        INFOGRAPHIC4: "Infographie 4",
                        INFOGRAPHIC5: "Infographie 5",
                        INFOGRAPHIC6: "Infographie 6",
                        BEGIN_PAGE:"Page de début",
                        END_PAGE:"Page de fin",
                        FEATURED:"Vedettes",
                    VR: "VR"
                    },
                Português: {
                        CREATE_ASSIGNMENT: "Criar Tarefa",
                        USERNAME: "Nome de usuário",
                        ENTER_USERNAME: "Insira nome de usuário",
                        PASSWORD: "Senha",
                        ENTER_PWD: "Digite a senha",
                        LOGIN: "Conecte-se",
                        STAY_SIGNED_IN: "Lembre-se de mim",
                        FORGOT_PWD: "Esqueceu o nome de utilizador/ palavra-passe?",
                        LOGIN_PROBLEM: "Ocorreu um problema ao fazer login, tente novamente.",
                        OK: "OK",
                        CANCEL: "Cancelar",
                        APPLY: "Aplique",
                        NO_ASSIGNMENTS: "Sem atribuições",
                        CLASS_ASSIGNMENTS: "Tarefas de classe",
                        SEARCH: "Procurar",
                        CONTENT: "Conteúdo",
                        ASSIGNMENTS: "Suas Tarefas",
                        LESSONS: "Planos de aula/recursos",
                        VIDEOS: "Vídeos",
                        INTERACTIVE: "Interativa",
                        EDITORS: "Editores",
                        ADMIN: "Admin",
                        USERS: "Comercial",
                        STUDENTS: "Alunas",
                        CLASSES: "Aulas",
                        USER: "Do utilizador",
                        SIGN_OUT: "Sair",
                        ID: "ID",
                        NAME: "Nome",
                        SUFFIX: "Sufixo",
                        TITLE: "Título",
                        CLASSNAME:"Nome da classe",
                        ASSIGNED_ON:"Atribuído em",
                        DUE_ON:"Devido a",
                        TEACHER_SEATS: "Assentos para professores",
                        STUDENT_SEATS: "Assentos para estudantes",
                        LICENSE_EXPIRES: "A licença expira",
                        LICENSE_BEGINS:"Início da licença",
                        EDIT: "Editar",
                        ASSUME: "Presumir",
                        DELETE: "Excluir",
                        NEW_TENANT: "Novo inquilino",
                        ENT_TEN_NAME: "Digite o nome do inquilino",
                        ENT_TEN_SUFFIX: "Digite o sufixo do inquilino",
                        CREATE: "Crio",
                        EDIT_TENANT: "Editar inquilino",
                        UPDATE_TENANT: "Atualizar inquilino",
                        CLASS: "Classe",
                        SELECT_STUDENT: "Selecionar Aluno",
                        ADD_TO_CLASS: "Adicionar à turma",
                        REMOVE: "Retirar",
                        ENT_CLASS_NAME: "Digite o nome da turma",
                        NEW_CLASS: "Nova classe",
                        FIRSTNAME: "Primeiro nome",
                        LASTNAME: "Último nome",
                        RESET_PW: "Redefinir senha",
                        ANSWER_SQ: "Responda às suas perguntas de segurança",
                        F_SQ: "Primeira pergunta de segurança",
                        S_SQ: "Segunda questão de segurança",
                        ENTER_ANSWER: "Digite sua resposta",
                        NEW_PW: "Nova senha",
                        NEW_PW_AGAIN: "Nova senha novamente",
                        SCHOOL: "Escola",
                        NEW_USER: "Novo usuário",
                        ENTER_USER_FIRSTNAME: "Digite o nome do usuário",
                        ENTER_USER_LASTNAME: "Digite o sobrenome do usuário",
                        ENTER_USER_PASSWORD: "Digite a senha do usuário",
                        ROLE: "Função",
                        NO_ENTRIES: "Nenhuma entrada",
                        SETUP_LATER: "Configuração posterior",
                        RESET_PASSWORD: "Redefinir senha",
                        GALLERY:"Galeria",
                        BIOGRAPHY:"Biografia",
                        IMAGE:"Imagem",
                        JIGSAW:"Quebra-cabeça",
                        VOCAB:"Vocabulário",
                        VIDEO:"Vídeo",
                        TIMELINE:"Linha do tempo",
                        INFOGRAPHIC1: "Infográfico 1",
                        INFOGRAPHIC2: "Infográfico 2",
                        INFOGRAPHIC3: "Infográfico 3",
                        INFOGRAPHIC4: "Infográfico 4",
                        INFOGRAPHIC5: "Infográfico 5",
                        INFOGRAPHIC6: "Infográfico 6",
                        BEGIN_PAGE:"Página inicial",
                        END_PAGE:"Página final",
                        FEATURED:"Destaque",
                    VR: "RV"
                    },
                Italiano: {
                        CREATE_ASSIGNMENT: "Crea compito",
                        USERNAME: "Nome utente",
                        ENTER_USERNAME: "Inserire username",
                        PASSWORD: "Parola d'ordine",
                        ENTER_PWD: "Inserire la password",
                        LOGIN: "Accesso",
                        STAY_SIGNED_IN: "Ricordati di me",
                        FORGOT_PWD: "Hai dimenticato nome utente / password?",
                        LOGIN_PROBLEM: "Si è verificato un problema durante l'accesso, per favore riprova.",
                        OK: "Va bene",
                        CANCEL: "Annulla",
                        APPLY: "Applicare",
                        NO_ASSIGNMENTS: "Nessun incarico",
                        CLASS_ASSIGNMENTS: "Compiti di classe",
                        SEARCH: "Ricerca",
                        CONTENT: "Soddisfare",
                        ASSIGNMENTS: "I tuoi incarichi",
                        LESSONS: "Piani di lezione/risorse",
                        VIDEOS: "Video",
                        INTERACTIVE: "Interactive",
                        EDITORS: "Editors",
                        ADMIN: "Admin",
                        USERS: "utenti",
                        STUDENTS: "Studentesse",
                        CLASSES: "Classi",
                        USER: "Utente",
                        SIGN_OUT: "disconnessione",
                        ID: "ID",
                        NAME: "Nome",
                        SUFFIX: "Suffisso",
                        TITLE: "Titolo",
                        CLASSNAME:"Nome della classe",
                        ASSIGNED_ON:"Assegnato",
                        DUE_ON:"Dovuto per",
                        TEACHER_SEATS: "Posti insegnante",
                        STUDENT_SEATS: "Posti per studenti",
                        LICENSE_EXPIRES: "La licenza scade",
                        LICENSE_BEGINS:"La licenza inizia",
                        EDIT: "modificare",
                        ASSUME: "Assumere",
                        DELETE: "Elimina",
                        NEW_TENANT: "Nuovo inquilino",
                        ENT_TEN_NAME: "Inserisci il nome dell'inquilino",
                        ENT_TEN_SUFFIX: "Immettere il suffisso del locatario",
                        CREATE: "Creare",
                        EDIT_TENANT: "Modifica inquilino",
                        UPDATE_TENANT: "Aggiorna tenant",
                        CLASS: "Classe",
                        SELECT_STUDENT: "Seleziona studente",
                        ADD_TO_CLASS: "Aggiungi alla classe",
                        REMOVE: "Rimuovere",
                        ENT_CLASS_NAME: "Inserisci il nome della classe",
                        NEW_CLASS: "Nuova classe",
                        FIRSTNAME: "Nome di battesimo",
                        LASTNAME: "Cognome",
                        RESET_PW: "Resetta la password",
                        ANSWER_SQ: "Rispondi alle tue domande di sicurezza",
                        F_SQ: "Prima domanda di sicurezza",
                        S_SQ: "Seconda domanda di sicurezza",
                        ENTER_ANSWER: "Inserisci la tua risposta",
                        NEW_PW: "Nuova password",
                        NEW_PW_AGAIN: "Conferma la nuova password",
                        SCHOOL: "Scuola",
                        NEW_USER: "Nuovo utente",
                        ENTER_USER_FIRSTNAME: "Immettere il nome utente",
                        ENTER_USER_LASTNAME: "Immettere il cognome dell'utente",
                        ENTER_USER_PASSWORD: "Immettere la password utente",
                        ROLE: "Ruolo",
                        NO_ENTRIES: "Nessuna voce",
                        SETUP_LATER: "Installazione successiva",
                        RESET_PASSWORD:"Resetta la password",
                        GALLERY:"Galleria",
                        BIOGRAPHY:"Biografia",
                        IMAGE:"Immagine",
                        JIGSAW:"puzzle",
                        VOCAB:"Vocabolario",
                        VIDEO:"video",
                        TIMELINE:"Sequenza temporale",
                        INFOGRAPHIC1: "Infografica 1",
                        INFOGRAPHIC2: "Infografica 2",
                        INFOGRAPHIC3: "Infografica 3",
                        INFOGRAPHIC4: "Infografica 4",
                        INFOGRAPHIC5: "Infografica 5",
                        INFOGRAPHIC6: "Infografica 6",
                        BEGIN_PAGE:"Inizia pagina",
                        END_PAGE:"Pagina finale",
                        FEATURED:"In primo piano",
                    VR: "VR"
                    }
                    
            }
    });

import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)

new Vue({
    i18n,
    router,
    render: h => h(App)

}).$mount('#app')
